import { createSlice } from "@reduxjs/toolkit";
import {
  adminAuthTokenCookieKey,
  adminProfileCookieKey,
  clientAuthTokenCookieKey,
  clientProfileCookieKey,
} from "../../../utils/constants";
import { removeCookie, setCookie } from "../../../utils/helpers";
import { AdminAuthProfile, AuthProfile } from "./auth.types";

const initialState: {
  profile: AuthProfile | null;
  isSignedIn: boolean;
  hasCreatedEvent: boolean;
  adminProfile: AdminAuthProfile | null;
  isAdminSignedIn: boolean;
} = {
  profile: null,
  isSignedIn: false,
  hasCreatedEvent: false,
  adminProfile: null,
  isAdminSignedIn: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    signUserIn: (
      state,
      action: {
        payload: { profile: AuthProfile; token: string };
        type: string;
      },
    ) => {
      setCookie(clientAuthTokenCookieKey, action.payload.token);
      setCookie(clientProfileCookieKey, JSON.stringify(action.payload.profile));
      state.profile = action.payload.profile;
      state.isSignedIn = true;
    },
    signAdminIn: (
      state,
      action: {
        payload: { profile: AdminAuthProfile; token: string };
        type: string;
      },
    ) => {
      setCookie(adminAuthTokenCookieKey, action.payload.token);
      setCookie(adminProfileCookieKey, JSON.stringify(action.payload.profile));
      state.adminProfile = action.payload.profile;
      state.isAdminSignedIn = true;
    },
    signUserOut: (state) => {
      removeCookie(clientAuthTokenCookieKey);
      removeCookie(clientProfileCookieKey);
      localStorage.removeItem("persist:root");
      state.profile = null;
      state.isSignedIn = false;
      state.hasCreatedEvent = false;
    },
    signAdminOut: (state) => {
      removeCookie(adminAuthTokenCookieKey);
      removeCookie(adminProfileCookieKey);
      localStorage.removeItem("persist:root");
      state.adminProfile = null;
      state.isAdminSignedIn = false;
    },
    updateProfile: (
      state,
      action: {
        payload: { profile: AuthProfile };
        type: string;
      },
    ) => {
      setCookie(clientProfileCookieKey, JSON.stringify(action.payload.profile));
      state.profile = action.payload.profile;
    },
    updateAdminProfile: (
      state,
      action: {
        payload: { profile: AdminAuthProfile };
        type: string;
      },
    ) => {
      setCookie(adminProfileCookieKey, JSON.stringify(action.payload.profile));
      state.adminProfile = action.payload.profile;
    },
    markCreateEvent: (state) => {
      state.hasCreatedEvent = true;
    },
    unMarkCreateEvent: (state) => {
      state.hasCreatedEvent = false;
    },
  },
});

export const authSliceReducer = authSlice.reducer;
export const authSliceActions = authSlice.actions;
export const authSliceReducerpath = authSlice.reducerPath;
